const commonCompanyPages: string[] = ['company', 'privacy', 'terms-of-service', '404'];

export default () => commonCompanyPages.some(url => new RegExp(`^/${url}`).test(location.pathname));



// WEBPACK FOOTER //
// ./app/assets/javascripts/helpers/checkAnyProduct.ts